import {tv, type VariantProps} from 'tailwind-variants'
import {cn} from '~/design-system/utils'

export type PermittedHeadingLevel = NonNullable<
  VariantProps<typeof wysiwygComponentVariants>['headingLevel']
>

// NB: The `cn` utility is used for readability
export const wysiwygComponentVariants = tv({
  slots: {
    blockQuote: cn(
      'wysiwyg-block-quote',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    body: cn(
      'wysiwyg-body',

      'next-wysiwyg-heading-2:mt-s7',
      '[&_+_.wysiwyg-heading-2_+_aside]:lg:mt-s7',
      '[&_+_aside_+_.wysiwyg-heading-2]:mt-s7',
      '[&_+_aside_+_.wysiwyg-heading-2_+_aside]:lg:mt-s7',

      'next-wysiwyg-heading-3:mt-s5',
      '[&_+_.wysiwyg-heading-3_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-3]:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-3_+_aside]:lg:mt-s5',

      'next-wysiwyg-heading-4:mt-s5',
      '[&_+_.wysiwyg-heading-4_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-4]:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-4_+_aside]:lg:mt-s5',

      'next-wysiwyg-body:mt-20',
      '[&_+_.wysiwyg-body_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-body]:mt-20',
      '[&_+_aside_+_.wysiwyg-body_+_aside]:lg:mt-20',

      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',

      'next-wysiwyg-block-quote:mt-20',
      '[&_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote]:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',

      'next-wysiwyg-code-block:mt-20',
      '[&_+_.wysiwyg-code-block_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block]:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block_+_aside]:lg:mt-20',

      'next-wysiwyg-divider:mt-s5',
      '[&_+_.wysiwyg-divider_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider]:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider_+_aside]:lg:mt-s5',

      'next-wysiwyg-embed:mt-s5',
      '[&_+_.wysiwyg-embed_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed]:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed_+_aside]:lg:mt-s5',

      'next-wysiwyg-list:mt-20',
      '[&_+_.wysiwyg-list_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-list]:mt-20',
      '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-20',

      'next-wysiwyg-media-asset:mt-s5',
      '[&_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-grid:mt-s5',
      '[&_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',

      'next-wysiwyg-promo:mt-s5',
      '[&_+_.wysiwyg-promo_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo]:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo_+_aside]:lg:mt-s5',

      'next-wysiwyg-pull-quote:mt-s5',
      '[&_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote]:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',

      'next-wysiwyg-statistic:mt-s5',
      '[&_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic]:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-20'
    ),
    codeBlock: cn(
      'wysiwyg-code-block',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      'next-wysiwyg-body:mt-20',
      '[&_+_.wysiwyg-body_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-body]:mt-20',
      '[&_+_aside_+_.wysiwyg-body_+_aside]:lg:mt-20',

      'next-wysiwyg-code-block:mt-20',
      '[&_+_.wysiwyg-code-block_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block]:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block_+_aside]:lg:mt-20',

      'next-wysiwyg-list:mt-20',
      '[&_+_.wysiwyg-list_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-list]:mt-20',
      '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-20',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    divider: cn(
      'wysiwyg-divider',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    embed: cn(
      'wysiwyg-embed',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    heading: cn(
      'wysiwyg-heading items-start',

      'next-wysiwyg-heading-2:mt-s5',
      '[&_+_.wysiwyg-heading-2_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-2]:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-2_+_aside]:lg:mt-s5',

      'next-wysiwyg-heading-3:mt-20',
      '[&_+_.wysiwyg-heading-3_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-heading-3]:mt-20',
      '[&_+_aside_+_.wysiwyg-heading-3_+_aside]:lg:mt-20',

      'next-wysiwyg-heading-4:mt-s3',
      '[&_+_.wysiwyg-heading-4_+_aside]:lg:mt-s3',
      '[&_+_aside_+_.wysiwyg-heading-4]:mt-s3',
      '[&_+_aside_+_.wysiwyg-heading-4_+_aside]:lg:mt-s3',

      'next-wysiwyg-body:mt-s2',
      '[&_+_.wysiwyg-body_+_aside]:lg:mt-s2',
      '[&_+_aside_+_.wysiwyg-body]:mt-s2',
      '[&_+_aside_+_.wysiwyg-body_+_aside]:lg:mt-s2',

      'next-wysiwyg-block-quote:mt-20',
      '[&_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote]:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',

      'next-wysiwyg-code-block:mt-20',
      '[&_+_.wysiwyg-code-block_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block]:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block_+_aside]:lg:mt-20',

      'next-wysiwyg-divider:mt-s5',
      '[&_+_.wysiwyg-divider_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider]:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider_+_aside]:lg:mt-s5',

      'next-wysiwyg-embed:mt-s5',
      '[&_+_.wysiwyg-embed_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed]:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-asset:mt-s5',
      '[&_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-grid:mt-s5',
      '[&_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',

      'next-wysiwyg-promo:mt-s5',
      '[&_+_.wysiwyg-promo_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo]:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo_+_aside]:lg:mt-s5',

      'next-wysiwyg-pull-quote:mt-s5',
      '[&_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote]:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',

      'next-wysiwyg-split-asset-component:mt-s5',
      '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-s5',
      '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',

      'next-wysiwyg-statistic:mt-20',
      '[&_+_.wysiwyg-statistic_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-statistic]:mt-20',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:lg:mt-20',

      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-20',
      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-20',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-20',

      '[&_+_aside]:mt-20'
    ),
    list: cn(
      'wysiwyg-list',

      'next-wysiwyg-heading-2:mt-s7',
      '[&_+_.wysiwyg-heading-2_+_aside]:lg:mt-s7',
      '[&_+_aside_+_.wysiwyg-heading-2]:mt-s7',
      '[&_+_aside_+_.wysiwyg-heading-2_+_aside]:lg:mt-s7',

      'next-wysiwyg-heading-3:mt-s5',
      '[&_+_.wysiwyg-heading-3_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-3]:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-3_+_aside]:lg:mt-s5',

      'next-wysiwyg-heading-4:mt-s5',
      '[&_+_.wysiwyg-heading-4_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-4]:mt-s5',
      '[&_+_aside_+_.wysiwyg-heading-4_+_aside]:lg:mt-s5',

      'next-wysiwyg-body:mt-20',
      '[&_+_.wysiwyg-body_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-body]:mt-20',
      '[&_+_aside_+_.wysiwyg-body_+_aside]:lg:mt-20',

      'next-wysiwyg-block-quote:mt-s5',
      '[&_+_.wysiwyg-block-quote_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-block-quote]:mt-s5',
      '[&_+_aside_+_.wysiwyg-block-quote_+_aside]:lg:mt-s5',

      'next-wysiwyg-code-block:mt-20',
      '[&_+_.wysiwyg-code-block_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block]:mt-20',
      '[&_+_aside_+_.wysiwyg-code-block_+_aside]:lg:mt-20',

      'next-wysiwyg-divider:mt-s5',
      '[&_+_.wysiwyg-divider_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider]:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider_+_aside]:lg:mt-s5',

      'next-wysiwyg-embed:mt-s5',
      '[&_+_.wysiwyg-embed_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed]:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed_+_aside]:lg:mt-s5',

      'next-wysiwyg-list:mt-20',
      '[&_+_.wysiwyg-list_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-list]:mt-20',
      '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-20',

      'next-wysiwyg-promo:mt-s5',
      '[&_+_.wysiwyg-promo_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo]:mt-s5',
      '[&_+_aside_+_.wysiwyg-promo_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-asset:mt-s5',
      '[&_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-grid:mt-s5',
      '[&_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',

      'next-wysiwyg-pull-quote:mt-s5',
      '[&_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote]:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',

      'next-wysiwyg-split-asset-component:mt-s5',
      '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-s5',
      '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',

      'next-wysiwyg-statistic:mt-s5',
      '[&_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic]:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',

      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    mediaAsset: cn(
      'wysiwyg-media-asset',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    mediaGrid: cn(
      'wysiwyg-media-grid',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    promo: cn(
      'wysiwyg-promo',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    pullQuote: cn(
      'wysiwyg-pull-quote',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    splitAssetAsset: 'wysiwyg-split-asset-asset',
    splitAssetComponent: cn(
      'wysiwyg-split-asset-component',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      'next-wysiwyg-body:mt-20',
      '[&_+_.wysiwyg-body_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-body]:mt-20',
      '[&_+_aside_+_.wysiwyg-body_+_aside]:lg:mt-20',

      'next-wysiwyg-block-quote:mt-20',
      '[&_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote]:mt-20',
      '[&_+_aside_+_.wysiwyg-block-quote_+_aside]:lg:mt-20',

      'next-wysiwyg-code-block:mt-s5',
      '[&_+_.wysiwyg-code-block_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-code-block]:mt-s5',
      '[&_+_aside_+_.wysiwyg-code-block_+_aside]:lg:mt-s5',

      'next-wysiwyg-divider:mt-s5',
      '[&_+_.wysiwyg-divider_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider]:mt-s5',
      '[&_+_aside_+_.wysiwyg-divider_+_aside]:lg:mt-s5',

      'next-wysiwyg-embed:mt-s5',
      '[&_+_.wysiwyg-embed_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed]:mt-s5',
      '[&_+_aside_+_.wysiwyg-embed_+_aside]:lg:mt-s5',

      'next-wysiwyg-list:mt-20',
      '[&_+_.wysiwyg-list_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-list]:mt-20',
      '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-20',

      'next-wysiwyg-media-asset:mt-s5',
      '[&_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-asset_+_aside]:lg:mt-s5',

      'next-wysiwyg-media-grid:mt-s5',
      '[&_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid]:mt-s5',
      '[&_+_aside_+_.wysiwyg-media-grid_+_aside]:lg:mt-s5',

      'next-wysiwyg-pull-quote:mt-s5',
      '[&_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote]:mt-s5',
      '[&_+_aside_+_.wysiwyg-pull-quote_+_aside]:lg:mt-s5',

      'next-wysiwyg-split-asset-component:mt-20',
      '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-20',
      '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-20',
      '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-20',

      'next-wysiwyg-statistic:mt-s5',
      '[&_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic]:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:lg:mt-s5',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
      '[&_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-20'
    ),
    statistic: cn(
      'wysiwyg-statistic',

      'next-wysiwyg-statistic:mt-s0',
      '[&_+_.wysiwyg-statistic_+_aside]:lg:mt-s0',
      '[&_+_aside_+_.wysiwyg-statistic]:lg:mt-s0',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:lg:mt-s0',
      '[&_+_aside_+_.wysiwyg-statistic]:mt-s5',
      '[&_+_aside_+_.wysiwyg-statistic_+_aside]:mt-s5',

      'next-wysiwyg-statistic:border-t-0',
      '[&_+_aside_+_.wysiwyg-statistic]:border-t-0',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
    table: cn(
      'wysiwyg-table',

      'next-wysiwyg-heading:mt-s8',
      '[&_+_.wysiwyg-heading_+_aside]:lg:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading]:mt-s8',
      '[&_+_aside_+_.wysiwyg-heading_+_aside]:lg:mt-s8',

      'next-wysiwyg-table:mt-s8',

      'next-wysiwyg-statistic:mt-s8',

      'next-wysiwyg-divider:mt-s8',

      '[&_+_*]:mt-s5',
      '[&_+_*_+_aside]:lg:mt-s5',
      '[&_+_aside_+_*]:mt-s5',
      '[&_+_aside_+_*_+_aside]:lg:mt-s5',

      '[&_+_aside]:mt-s5'
    ),
  },
  variants: {
    bodyVariant: {
      'body-1': {
        body: cn(
          'wysiwyg-body-1',

          'next-wysiwyg-split-asset-component:mt-s5',
          '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',
          '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-s5',
          '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5'
        ),
      },
      'body-2': {
        body: cn(
          'wysiwyg-body-2',

          'next-wysiwyg-split-asset-component:mt-s0',
          '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s0',
          '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-s0',
          '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s0',

          '[&:has(.wysiwyg-dropcap)_+_.wysiwyg-body-2]:mt-s0',
          '[&:has(.wysiwyg-dropcap)_+_.wysiwyg-body-2_+_aside]:lg:mt-s0',
          '[&:has(.wysiwyg-dropcap)_+_aside_+_.wysiwyg-body-2]:lg:mt-s0',
          '[&:has(.wysiwyg-dropcap)_+_aside_+_.wysiwyg-body-2_+_aside]:lg:mt-s0',

          '[&:has(.wysiwyg-dropcap)_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
          '[&:has(.wysiwyg-dropcap)_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5',
          '[&:has(.wysiwyg-dropcap)_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)]:mt-s5',
          '[&:has(.wysiwyg-dropcap)_+_aside_+_.wysiwyg-body-2:has(.wysiwyg-dropcap)_+_aside]:lg:mt-s5'
        ),
      },
      'body-3': {
        body: cn(
          'wysiwyg-body-3',

          'next-wysiwyg-split-asset-component:mt-s5',
          '[&_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5',
          '[&_+_aside_+_.wysiwyg-split-asset-component]:mt-s5',
          '[&_+_aside_+_.wysiwyg-split-asset-component_+_aside]:lg:mt-s5'
        ),
      },
    },
    headingLevel: {
      2: {
        heading: cn(
          'wysiwyg-heading-2',

          'next-wysiwyg-list:mt-20',
          '[&_+_.wysiwyg-list_+_aside]:lg:mt-20',
          '[&_+_aside_+_.wysiwyg-list]:mt-20',
          '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-20'
        ),
      },
      3: {
        heading: cn(
          'wysiwyg-heading-3',

          'next-wysiwyg-list:mt-s3',
          '[&_+_.wysiwyg-list_+_aside]:lg:mt-s3',
          '[&_+_aside_+_.wysiwyg-list]:mt-s3',
          '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-s3'
        ),
      },
      4: {
        heading: cn(
          'wysiwyg-heading-4',
          'text-pretty',

          'next-wysiwyg-list:mt-s3',
          '[&_+_.wysiwyg-list_+_aside]:lg:mt-s3',
          '[&_+_aside_+_.wysiwyg-list]:mt-s3',
          '[&_+_aside_+_.wysiwyg-list_+_aside]:lg:mt-s3'
        ),
      },
    },
    mediaAssetSize: {
      xs: {
        mediaAsset: 'wysiwyg-media-asset-xs',
      },
      small: {
        mediaAsset: 'wysiwyg-media-asset-small',
      },
      medium: {
        mediaAsset: 'wysiwyg-media-asset-medium',
      },
      large: {
        mediaAsset: 'wysiwyg-media-asset-large',
      },
      xl: {
        mediaAsset: 'wysiwyg-media-asset-xl',
      },
    },
    mediaGridSize: {
      small: {mediaGrid: ''},
      medium: {mediaGrid: ''},
      large: {mediaGrid: ''},
    },
    mediaGridNumberOfAssets: {
      2: {mediaGrid: 'wysiwyg-media-grid-2-up'},
      3: {mediaGrid: 'wysiwyg-media-grid-3-up'},
      4: {mediaGrid: 'wysiwyg-media-grid-4-up'},
    },
  },
  compoundVariants: [
    {
      mediaGridSize: 'small',
      mediaGridNumberOfAssets: 2,
      class: {mediaGrid: 'wysiwyg-media-grid-2-up-small'},
    },
    {
      mediaGridSize: 'medium',
      mediaGridNumberOfAssets: 2,
      class: {mediaGrid: 'wysiwyg-media-grid-2-up-medium'},
    },
    {
      mediaGridSize: 'large',
      mediaGridNumberOfAssets: 2,
      class: {mediaGrid: 'wysiwyg-media-grid-2-up-large'},
    },
  ],
})
